import * as React from 'react';
import { Box, Button, Avatar, Menu, MenuButton, MenuList, Icon, Text } from '@chakra-ui/react';
import { FaUser } from 'react-icons/fa'; // Import a different user icon
import { signOutUser } from '../../utils/signout'; // Import the sign-out function

const ProfileMenu = ({ name, email, onProfileClick }) => {
  const navigateToProfile = () => {
    onProfileClick(); // Call the passed down handler
  };

  const handleSignOut = () => {
    signOutUser(); // Call the sign-out function
  };

  return (
    <Menu>
      <MenuButton as={Button} variant="ghost" rounded="full">
        <Avatar
          size="sm"
          icon={<Icon as={FaUser} color="white" />} // Set icon color to white
          bg="blue.500" // Set background color to blue
        />
      </MenuButton>
      <MenuList zIndex={2}>
        <Box p={4} textAlign="center">
          <Avatar
            size="xl"
            icon={<Icon as={FaUser} color="white" />} // Set icon color to white
            bg="blue.500" // Set background color to blue
            mb={2}
          />
          <Text fontWeight="bold">{name}</Text>
          <Text fontSize="sm" color="gray.500">{email}</Text>
          <Box display="flex" justifyContent="space-between" mt={4}>
            <Button size="sm" colorScheme="blue" onClick={navigateToProfile} width="48%">
              Profile
            </Button>
            <Button size="sm" colorScheme="red" onClick={handleSignOut} width="48%">
              Log Out
            </Button>
          </Box>
        </Box>
      </MenuList>
    </Menu>
  );
}

export default ProfileMenu;